const lngs = {
    en: { nativeName: 'English' },
    de: { nativeName: 'Deutsch' }
};

export default lngs;